export const NumberUtils = {
    /**
     * Generate a random integer between 0 and max (max not included)
     */
    randInt: (max = 100): number => {
        return Math.floor(Math.random() * max);
    },
};
